// Mock data for EdyNexa OSSD website

export const heroData = {
  title: "Your Gateway to Global Universities",
  subtitle: "Ontario Secondary School Diploma (OSSD)",
  description: "The One True Global Qualification for Direct University Admission Worldwide",
  cta1: "Enquire Now",
  cta2: "Book Free Consultation",
  heroImage: "https://images.unsplash.com/photo-1758270703127-9f6ae686ce7b"
};

export const aboutOSSDData = {
  title: "What is OSSD?",
  description: "The Ontario Secondary School Diploma (OSSD) is a fully regulated public qualification awarded by the Ministry of Education, Ontario, Canada. It is internationally recognized and provides guaranteed direct entry to universities worldwide.",
  features: [
    {
      icon: "Globe",
      title: "Globally Recognized",
      description: "Accepted by top universities across Canada, USA, UK, Australia, and more"
    },
    {
      icon: "Award",
      title: "Fully Regulated",
      description: "Official qualification from Ontario Ministry of Education"
    },
    {
      icon: "TrendingUp",
      title: "Direct University Entry",
      description: "Guaranteed admission pathway to international universities"
    },
    {
      icon: "Users",
      title: "Proven Success",
      description: "Thousands of students successfully placed in top global universities"
    }
  ],
  image: "https://images.unsplash.com/photo-1765024142859-c7c278587f0d"
};

export const whyEduNexaData = {
  title: "Why Choose EduNexa?",
  subtitle: "Your Trusted Partner for OSSD Success",
  reasons: [
    {
      icon: "CheckCircle",
      title: "Accredited Partner Center",
      description: "Official authorized center for OSSD program delivery"
    },
    {
      icon: "DollarSign",
      title: "Affordable Program Cost",
      description: "Competitively priced compared to other international pathway programs"
    },
    {
      icon: "BookOpen",
      title: "Experienced Faculty",
      description: "Professional educators with real-world experience and proven teaching excellence"
    },
    {
      icon: "HeadphonesIcon",
      title: "Comprehensive Support",
      description: "Personalized academic guidance and continuous student support throughout your journey"
    },
    {
      icon: "Target",
      title: "University Placement Support",
      description: "Expert guidance for university applications and admissions worldwide"
    },
    {
      icon: "Clock",
      title: "Flexible Learning",
      description: "Structured program designed to fit your academic goals and timeline"
    }
  ],
  backgroundImage: "https://images.unsplash.com/photo-1758413355194-353da4fa09c1"
};

export const programStructureData = {
  title: "OSSD Program Structure",
  subtitle: "Complete Your Diploma in 7 Strategic Modules",
  compulsoryModules: [
    {
      code: "ENG3U",
      title: "Year 11 English",
      description: "Advanced English language and literature studies"
    },
    {
      code: "ENG4U",
      title: "Year 12 English",
      description: "University-level English comprehension and writing"
    },
    {
      code: "MHF4U",
      title: "Advanced Functions",
      description: "Mathematical concepts for university preparation"
    },
    {
      code: "MCV4U",
      title: "Calculus and Vectors",
      description: "Advanced mathematics for science and engineering"
    }
  ],
  streams: [
    {
      name: "Science Stream",
      modules: [
        { code: "SBI4U", title: "Biology", icon: "Microscope" },
        { code: "SCH4U", title: "Chemistry", icon: "TestTube" },
        { code: "SPH4U", title: "Physics", icon: "Atom" }
      ]
    },
    {
      name: "Business Stream",
      modules: [
        { code: "BBB4M", title: "International Business", icon: "Briefcase" },
        { code: "BOH4M", title: "Business Leadership", icon: "Users" },
        { code: "CIA4U", title: "Economic Issues", icon: "TrendingUp" }
      ]
    },
    {
      name: "Computing & Engineering",
      modules: [
        { code: "ICS4U", title: "Computer Science", icon: "Code" },
        { code: "TEJ4M", title: "Computer Engineering", icon: "Cpu" },
        { code: "MDM4U", title: "Data Management", icon: "Database" }
      ]
    }
  ]
};

export const universityPartnersData = {
  title: "University Pathways",
  subtitle: "OSSD Opens Doors to World-Class Universities",
  description: "Our OSSD graduates gain direct admission to hundreds of prestigious universities worldwide",
  universities: [
    { name: "University of Toronto", country: "Canada", ranking: "Top 20 Global" },
    { name: "University of British Columbia", country: "Canada", ranking: "Top 50 Global" },
    { name: "McGill University", country: "Canada", ranking: "Top 30 Global" },
    { name: "McMaster University", country: "Canada", ranking: "Top 100 Global" },
    { name: "Western University", country: "Canada", ranking: "Top 200 Global" },
    { name: "York University", country: "Canada", ranking: "Top 300 Global" },
    { name: "University of Waterloo", country: "Canada", ranking: "Top 150 Global" },
    { name: "Queen's University", country: "Canada", ranking: "Top 200 Global" },
    { name: "University of Melbourne", country: "Australia", ranking: "Top 40 Global" },
    { name: "Imperial College London", country: "UK", ranking: "Top 10 Global" },
    { name: "University of Manchester", country: "UK", ranking: "Top 30 Global" },
    { name: "Boston University", country: "USA", ranking: "Top 50 Global" }
  ],
  image: "https://images.unsplash.com/photo-1734278175955-cda14a411c43"
};

export const testimonialsData = {
  title: "Success Stories",
  subtitle: "Hear From Our OSSD Graduates",
  testimonials: [
    {
      name: "Ananya Perera",
      university: "University of Toronto",
      program: "Computer Science",
      quote: "EdyNexa's OSSD program transformed my academic journey. The structured curriculum and dedicated support helped me secure admission to my dream university in Canada.",
      image: "https://images.unsplash.com/photo-1762438136374-b2fe754053f0"
    },
    {
      name: "Ravindu Silva",
      university: "University of British Columbia",
      program: "Business Administration",
      quote: "The OSSD qualification through EdyNexa gave me the competitive edge I needed. The faculty's guidance throughout the admission process was invaluable.",
      image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c"
    },
    {
      name: "Tharushi Fernando",
      university: "McGill University",
      program: "Biological Sciences",
      quote: "I'm grateful for EdyNexa's comprehensive approach. From academics to university applications, they supported me every step of the way to achieve my goals.",
      image: "https://images.unsplash.com/photo-1728455635901-bb16530faf40"
    }
  ]
};

export const admissionProcessData = {
  title: "Admission Process",
  subtitle: "Your Journey to Global Education Starts Here",
  steps: [
    {
      step: "1",
      title: "Initial Consultation",
      description: "Schedule a free consultation to discuss your academic goals and eligibility",
      icon: "MessageCircle"
    },
    {
      step: "2",
      title: "Application Submission",
      description: "Complete the application form with your academic transcripts and documents",
      icon: "FileText"
    },
    {
      step: "3",
      title: "Assessment & Enrollment",
      description: "Our team reviews your application and confirms your enrollment in the OSSD program",
      icon: "ClipboardCheck"
    },
    {
      step: "4",
      title: "Begin Your Studies",
      description: "Start your OSSD journey with expert guidance and comprehensive support",
      icon: "GraduationCap"
    }
  ],
  eligibility: {
    title: "Eligibility Requirements",
    requirements: [
      "Completed O/Level examinations or equivalent",
      "Minimum passes in required subjects",
      "English language proficiency",
      "Commitment to academic excellence"
    ]
  }
};

export const faqData = {
  title: "Frequently Asked Questions",
  subtitle: "Everything You Need to Know About OSSD",
  faqs: [
    {
      question: "What is the OSSD and why is it valuable?",
      answer: "The Ontario Secondary School Diploma (OSSD) is a fully regulated public qualification from Ontario, Canada. It's recognized globally and provides guaranteed direct admission to universities worldwide, making it one of the most valuable international secondary school qualifications."
    },
    {
      question: "How long does it take to complete the OSSD program?",
      answer: "The OSSD program typically takes 12-18 months to complete, depending on your academic background and chosen stream. The program consists of 7 modules including 4 compulsory subjects and 3 stream-specific electives."
    },
    {
      question: "What universities accept OSSD graduates?",
      answer: "OSSD is recognized by hundreds of universities worldwide, including top institutions in Canada, USA, UK, Australia, and other countries. Our graduates have been accepted to prestigious universities like University of Toronto, UBC, McGill, and many more."
    },
    {
      question: "What are the admission requirements for EdyNexa's OSSD program?",
      answer: "Students who have completed O/Level examinations or equivalent qualifications are eligible. Specific subject requirements and minimum grades vary by chosen stream. Contact us for a detailed assessment of your eligibility."
    },
    {
      question: "How does EdyNexa support students throughout the program?",
      answer: "We provide comprehensive support including experienced faculty, personalized academic guidance, university application assistance, and continuous mentoring. Our goal is to ensure every student succeeds in their OSSD journey and university placement."
    },
    {
      question: "What makes EdyNexa different from other OSSD providers?",
      answer: "EdyNexa is an accredited partner center with proven expertise in OSSD delivery. We offer affordable program costs, experienced faculty with real-world knowledge, and dedicated university placement support that ensures your success from enrollment to admission."
    },
    {
      question: "Can I choose my university major with OSSD?",
      answer: "Yes! Our program offers three streams - Science, Business, and Computing & Engineering. Choose modules aligned with your intended university major and career goals. Our advisors will help you select the best pathway."
    },
    {
      question: "What is the cost of the OSSD program?",
      answer: "Our OSSD program is competitively priced and more affordable than most international pathway programs. Contact us for detailed fee information and available payment plans tailored to your needs."
    }
  ]
};

export const contactData = {
  title: "Ready to Begin Your Journey?",
  subtitle: "Get in Touch With Our Admissions Team",
  contactInfo: {
    email: "info@edunexa.ca",
    phone: "+1 (519) 500-5823",
    whatsapp: "+1 (519) 500-5823",
    address: "Ontario, Canada"
  },
  socialMedia: {
    facebook: "https://facebook.com/edunexa",
    instagram: "https://instagram.com/edunexa",
    linkedin: "https://linkedin.com/company/edunexa"
  },
  officeHours: "Monday - Friday: 9:00 AM - 5:00 PM EST | Saturday - Sunday: Closed",
  logo: "https://customer-assets.emergentagent.com/job_eae76a40-ac03-4a31-a3ef-4e96d1f75339/artifacts/liore9ya_Logo%20%281%29.png"
};
